window.addEventListener('DOMContentLoaded', () => {
  window.copy = function(text) {
    let dummy = document.createElement("input");
    dummy.value = text
    document.body.appendChild(dummy);
    dummy.select();
    dummy.setSelectionRange(0, 99999) /* For mobile devices */
    document.execCommand("copy");
    dummy.remove()
  }
})
